var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRighthalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 22,
    viewBox: "0 0 42 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1707",
    d: "M41.3478 0.528242C41.3689 3.24928 40.8523 5.94769 39.8276 8.46852C38.803 10.9894 37.2904 13.2829 35.3769 15.2176C33.4634 17.1522 31.1865 18.6898 28.6771 19.7421C26.1676 20.7943 23.475 21.3405 20.7539 21.3492C18.0328 21.358 15.3368 20.8291 12.8206 19.793C10.3045 18.7568 8.01782 17.2339 6.0919 15.3116C4.16598 13.3892 2.63876 11.1054 1.59795 8.59119C0.557133 6.07699 0.0232224 3.38195 0.0268751 0.66083L11.0119 0.675576C11.0102 1.94992 11.2602 3.21204 11.7476 4.38948C12.2351 5.56692 12.9503 6.63647 13.8522 7.53673C14.7542 8.43698 15.8251 9.1502 17.0034 9.63543C18.1817 10.1207 19.4443 10.3683 20.7187 10.3643C21.993 10.3602 23.254 10.1044 24.4292 9.61161C25.6044 9.11882 26.6707 8.39875 27.5668 7.49272C28.463 6.5867 29.1713 5.51257 29.6512 4.33203C30.131 3.15149 30.373 1.88779 30.3631 0.613483L41.3478 0.528242Z",
    fill: "#163E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRighthalf);
export default __webpack_public_path__ + "static/media/righthalf.b7de9644297dd5f71930d69adf3f0734.svg";
export { ForwardRef as ReactComponent };